import React, { useState, useRef, useEffect } from "react"
import { Form, Alert, Button, Card, Modal, Spinner } from "react-bootstrap"
import { useAuth } from "../contexts/AuthContext"
import { useHistory } from "react-router-dom"
import { db } from "./../firebase"
import { doc, updateDoc, onSnapshot, Timestamp } from "firebase/firestore"
import { postHttp } from "../api/HttpClient"
import CenteredContainer from "./CenteredContainer"
import Image from "react-bootstrap/Image"
import DropdownButton from "react-bootstrap/DropdownButton"
import Dropdown from "react-bootstrap/Dropdown"
import { optionRegistration } from "../helpers/Data"
import QRCode from "react-qr-code"
import { Link } from "react-bootstrap-icons"

export default function Dashboard() {
  const [error, setError] = useState("")
  const [currentCategory, setCurrentCategory] = useState("")
  const [activeQR, setActiveQR] = useState(false)
  // const [statusPendiente, setStatusPendiente] = useState("")
  const [timeLeft, setTimeLeft] = useState(0)
  const [minutesLeft, setMinutesLeft] = useState(0)
  const [expireDate, setExpireDate] = useState("")
  const { currentUser, logout, currentAdmin, currentBecario } = useAuth()
  const [loading, setLoading] = useState(false)
  const [currentProfile, setCurrentProfile] = useState({})
  const [visibleQr, setVisibleQr] = useState(false)
  const [verifyQR, setVerifyQR] = useState(false)
  const [responseRq, setResponseRq] = useState(null)
  const [dataSelect, setDataSelect] = useState(optionRegistration[0])
  const history = useHistory()
  const docRef = doc(db, "users", currentUser.uid)
  const paperRef = useRef()

  const [paymentTypeQR, setPaymentTypeQR] = useState(false)
  const [paymentTypePayPal, setPaymentTypePayPal] = useState(false)

  // console.log(currentUser.becario)
  // Hook to listen firestore in real time
  useEffect(() => {
    const unsubDoc = onSnapshot(docRef, (snapshot) => {
      setCurrentProfile(snapshot.data())
      // console.log(currentUser.uid)
    })
    return () => unsubDoc()
  }, [])

  // const unsuscribe = onSnapshot(docRef,(snapshot) => {
  //   console.log(snapshot.data())
  // })

  // unsuscribe()

  // Hook to check status everytime the data on the current user changes
  useEffect(() => {
    if (currentProfile != null) {
      ;(async () => docSnap())()
    }
  }, [currentProfile.status])

  // Load data
  const docSnap = async () => {
    // console.log('this doc snap')

    setLoading(true)

    // Check QR status
    // console.log(currentProfile)

    await checkVerify(currentProfile)

    // Reset loading state
    setLoading(false)
  }

  // Check if user is subscribed
  const checkVerify = async (profileData) => {
    // if (!currentProfile.subscription) {
    await verifyPayment(profileData)

    // } else {
    // console.log(currentProfile.subscription)
    // setStatusInscrito("Correctly subscribed")

    // }
  }

  // Payment verification
  const verifyPayment = async (profileData) => {
    // console.log(profileData)

    setLoading(true)

    if (profileData?.payment_id > 0 && profileData?.status !== 2) {
      const body = {
        order_owner: "Qr",
        payment_id: profileData.payment_id,
      }
      const { response, success, errorData, message } = await postHttp(
        "verify",
        body
      )
      if (success) {
        // console.log(' response ', response);
        if (response?.state) {
          if (response?.state === 2) {
            const subscribeEvent = response?.state === 2 ? true : false
            const paymentTimeStamp = new Date(
              Timestamp.now().toDate().toString()
            )

            const dateStampUse = new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            }).format(paymentTimeStamp)

            const model = {
              ...profileData,
              subscription: subscribeEvent,
              status: response?.state,
              lastPayment: dateStampUse,
            }
            await updateDoc(docRef, "subscription", subscribeEvent)
            await updateDoc(docRef, "status", response?.state)
            await updateDoc(docRef, "lastPayment", dateStampUse)
            setCurrentProfile(model)
            setResponseRq(response)
          } else if (response?.state === 6) {
            const model = { ...profileData, subscription: false, status: 0 }
            await updateDoc(docRef, "subscription", false)
            await updateDoc(docRef, "status", 0)
            await updateDoc(docRef, "payment_id", 0)
            setCurrentProfile(model)
            setResponseRq(null)
          } else if (response?.state === "98") {
            const model = { ...profileData, subscription: false, status: 0 }
            await updateDoc(docRef, "subscription", false)
            await updateDoc(docRef, "status", 0)
            await updateDoc(docRef, "payment_id", 0)
            setCurrentProfile(model)
            setResponseRq(null)
          } else if (response?.state === 1) {
            setResponseRq(response)
            var dt = new Date(profileData.expiration_date)
            // var dtnow = new Date()
            // console.log('expiration',dt);

            var caracas_datetime_str = new Date(
              profileData.expiration_date
            ).toLocaleString("en-US", { timeZone: "America/Caracas" })
            var dtNow = new Date(caracas_datetime_str)
            // console.log('now', dt);
            // console.log(caracas_datetime_str)

            var timeDiff = Math.abs(dtNow - dt)
            // var hourLeft = Math.floor((timediff % 86400000) / 3600000);

            var hours = Math.floor(timeDiff / 3.6e6)
            var minutes = Math.floor((timeDiff % 3.6e6) / 6e4)

            setActiveQR(true)
            setTimeLeft(hours)
            setExpireDate(caracas_datetime_str)
            setMinutesLeft(minutes)
            // console.log(response)
          }
        }
      } else {
        const { code, error, state } = errorData
        alert(message)
      }
    }
    setLoading(false)
  }

  // Log out from dashboard
  async function handleLogout() {
    setError("")

    try {
      await logout()
      history.push("/login")
    } catch (error) {
      setError("Failed to log out")
      // console.log(error)
    }
  }

  // Get price based on selection
  const getPriceByType = async () => {
    switch (dataSelect?.value) {
      case "Expositor":
        return 345
      case "Professional":
        return 250
      case "Student":
        return 100
      // case "StudentPlus":
      //   return 310
      default:
        return 0
    }
  }

  // Subscribe button
  const handleSubscribe = async (e) => {
    e.preventDefault()
    setPaymentTypePayPal(false)
    setPaymentTypeQR(false)
    setLoading(true)
    setError()
    if (currentProfile?.uid && dataSelect?.value !== "select") {
      const category = dataSelect?.value
      const price = await getPriceByType()
      const body = {
        order_owner: "BCDE14",
        provider_uid: "Ic5wEhQv2XX6zKvoJ6VZXrSc6c42",
        quantity: 1,
        customer_id: currentProfile?.uid,
        first_name: currentProfile?.Name + " " + currentProfile?.Surname,
        email: currentProfile?.email,
        mobile: "5235235423",
        provider_id: "5235235423",
        provider_name: "SEBOL",
        provider_email: "pcubaborda@gmail.com",
        amount: price,
        discount: 0,
        shippin: 0,
        tax: 0,
        items: [],
        total: price,
        order_code: "qr-evento",
        date_schedule: new Date(),
        client_code: "qua",
        concept: category + " BCDE 14",
        description: "BCDE 14",
        payment_id: 0,
        category: category,
      }
      const { response, success, error, status } = await postHttp(
        "bookingPay",
        body
      )
      if (success) {
        await updatePayment(response, category)
      }
    } else {
      setError("Selecciona una opción")
    }
    setLoading(false)
  }

  //
  const updatePayment = async (responseData, category) => {
    const payment_id = responseData?.payment_id ? responseData?.payment_id : 0
    const profileNew = {
      ...currentProfile,
      payment_id,
      status: 1,
      expiration_date: responseData.expiration_date,
      category: category,
      paymentType: "QR",
    }

    // console.log('Response Data', responseData)
    setCurrentProfile(profileNew)
    setResponseRq(responseData)
    await updateDoc(docRef, "payment_id", payment_id)
    await updateDoc(docRef, "status", 1)
    await updateDoc(docRef, "expiration_date", responseData.expiration_date)
    await updateDoc(docRef, "category", category)
    await updateDoc(docRef, "paymentType", "QR")
    setCurrentCategory(category)
    setCurrentProfile({ ...profileNew, category: currentCategory })

    var caracas_datetime_str = new Date(
      responseData.expiration_date
    ).toLocaleString("en-US", { timeZone: "America/Caracas" })
    setExpireDate(caracas_datetime_str)

    // console.log(currentProfile)
    // setVisibleQr(true)
  }

  // Close QR modal
  const handleClose = () => {
    setVisibleQr(false)
  }

  // Show Modal with QR
  const handleShowQr = (e) => {
    e.preventDefault()
    // setVisibleQr(true)
    // console.log(' event ', visibleQr);
  }

  // Verify QR
  const handleVerifyQr = async (e) => {
    e.preventDefault()
    if (currentProfile?.uid) {
      await verifyPayment(currentProfile)
    }
    setVerifyQR(true)
  }

  // Spinner
  const LoadSpinner = () => {
    return (
      <>
        {loading && (
          <div className={"d-flex justify-content-center"}>
            <Spinner animation='border' role='status'>
              <span className='visually-hidden'> Loading...</span>
            </Spinner>
          </div>
        )}
      </>
    )
  }

  async function updateProfile(newProfileData) {
    const data = newProfileData
    try {
      await updateDoc(docRef, data)
    } catch (err) {
      console.log(err)
    }
  }

  async function redirectToExternalURL(e) {
    e.preventDefault()
    // const promises = []
    setPaymentTypePayPal(false)
    setPaymentTypeQR(false)

    setLoading(true)
    setError("")

    let newProfileData = {}

    // Paper ref
    newProfileData.paymentType = "PayPal"
    newProfileData.status = 10
    LoadSpinner()
    try {
      console.log(newProfileData)
      await updateProfile(newProfileData)
    } catch (err) {
      console.log("Error handling PayPal redirect")
      console.log(err)
    }

    setLoading(false)

    window.open("https://www.paypal.com/paypalme/SEBOLBCDE", "_blank") // Opens in a new window/tab
  }

  // Submit changes to profile
  async function handlePaperId(e) {
    e.preventDefault()

    // const promises = []
    setLoading(true)
    setError("")

    let newProfileData = {}

    // Paper ref
    newProfileData.paperID = paperRef.current.value

    LoadSpinner()
    try {
      console.log(newProfileData)
      await updateProfile(newProfileData)
    } catch (err) {
      console.log("Error handling paper ID")
      console.log(err)
      // setError(err.message)
      // setMessage(error)
    }

    setLoading(false)
  }

  function handlePaymentQR(e) {
    e.preventDefault()

    setPaymentTypePayPal(false)
    setPaymentTypeQR(!paymentTypeQR)
  }

  function handlePaymentPayPal(e) {
    e.preventDefault()
    setPaymentTypeQR(false)
    setPaymentTypePayPal(!paymentTypePayPal)
  }

  // QR status
  const showStatusQr = () => {
    // console.log('current Profile: ', currentProfile);

    if (currentProfile.subscription === false) {
      switch (currentProfile.status) {
        case 1:
          return (
            <div>
              <Alert variant='warning'>
                <div className='text-center'>
                  <div className='fs-5'>
                    Pago Pendiente
                    <p className='fs-6'>
                      {" "}
                      Por favor pague el siguiente código QR usando su
                      aplicación de banca móvil
                    </p>
                    <hr className='hr-danger' />
                  </div>

                  <div>
                    Categoria:
                    <p className=' text-success text-center'>
                      {responseRq?.concept}
                    </p>
                  </div>
                  {activeQR === true && (
                    <div>
                      <div className='d-flex justify-content-center'>
                        <img
                          src={`data:image;base64,${responseRq?.qr}`}
                          alt='Qr'
                        />
                      </div>
                      <hr className='hr-danger' />
                      Código QR expira en:
                      {/* <div className="text-danger text-center">{timeLeft} horas y {minutesLeft} minutos</div> */}
                      <div className='text-danger text-center'>
                        {responseRq?.expiration_date}
                      </div>
                    </div>
                  )}
                </div>
              </Alert>
            </div>
          )

        case 10:
          return (
            <div>
              <Alert variant='warning'>
                <div className='text-center'>
                  <div className='fs-5'>
                    Pago PayPal
                    <p className='fs-6'>
                      <a
                        href='https://www.paypal.com/paypalme/SEBOLBCDE'
                        target='_blank'
                      >
                        paypal.me/SEBOLBCDE
                      </a>
                    </p>
                    <p className='fs-6'>
                      {" "}
                      Por favor completa el pago de <b>50$US</b> usando el link
                      de PayPal. Una vez verificada tu transacción veras un
                      mensaje de confirmación acá.
                    </p>
                    <p className='text-secondary fs-6'>
                      {" "}
                      Please complete your registration payment of <b>
                        50$US
                      </b>{" "}
                      using the PayPal link. Once we verify your transaction you
                      will see a confirmation message on this page.
                    </p>
                    <hr className='hr-danger' />
                  </div>

                  <div>
                    Categoria:
                    <p className=' text-success text-center'>
                      Expositor BCDE 14
                    </p>
                  </div>
                </div>
              </Alert>
            </div>
          )
        case 3:
          return "Rechazado"
        case 4:
          return "Error"
        case 5:
          return "Revertido"
        case 6:
          return "Vencido"

        default:
          return ""
      }
    } else {
      return (
        <>
          <Alert variant='success'>
            <div className='text-center'>
              <h4> Inscripción exitosa </h4>
              <p> Successful registration </p>
              {/* <i className="bi bi-check-circle"></i> */}

              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='40'
                height='40'
                fill='currentColor'
                className='bi bi-check-circle'
                viewBox='0 0 16 16'
              >
                <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
                <path d='M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z' />
              </svg>
              <div className='fs-5 mt-3'>
                Categoria: {currentProfile.category}
              </div>
            </div>
          </Alert>
          {/* <p className='text-center'>
            Usa este código para acceder a tu evento
          </p>
          <div
            className='text-center'
            style={{ height: "200px", width: "100%" }}
          >
            {currentProfile.uid && (
              <QRCode
                id='QRCode'
                size={256}
                style={{ height: "200", width: "200" }}
                title='Custom Title'
                value={currentProfile.uid}
                viewBox={`0 0 256 256`}
              />
            )}
          </div> */}
        </>
      )
    }
  }

  // Registration section
  const showActionSubscribe = () => {
    if (currentProfile.subscription === false) {
      switch (currentProfile.status) {
        case 1:
          // {console.log('responseRq',responseRq)}

          return (
            <>
              {/* <h4 className="text-center mt-4 ">Registration Pending</h4> */}
              <div className={"d-flex justify-content-around w-100"}>
                <Button
                  className={"w-50 m-1"}
                  variant='secondary'
                  onClick={() => handleDownload()}
                >
                  Descargar
                </Button>

                {/* <Button
                  disabled={loading}
                  className='w-50 m-1'
                  type='submit'
                  onClick={handleShowQr}
                >
                  Mostrar QR
                </Button> */}
                <Button
                  className={"w-50 m-1"}
                  variant='success'
                  onClick={handleVerifyQr}
                >
                  Verificar Pago
                </Button>
              </div>
            </>
          )
        case 2:
          return <></>
        case 0:
          return (
            <>
              <h4 className='text-center mb-4 mt-4 '>
                Select your registration
              </h4>
              <div className='w-100 text-center mt-2'>
                <DropdownButton
                  title={dataSelect.label}
                  id='dropdown-menu-align-right'
                  onSelect={handleSelect}
                >
                  {optionRegistration.map((item, index) => (
                    <Dropdown.Item
                      key={index}
                      eventKey={item.value}
                      active={dataSelect?.value === item.value ? true : false}
                    >
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </div>

              {<div className='mt-4 mb-4'>{showData()}</div>}
            </>
          )
        default:
          return <></>
      }
    } else {
      return <></>
    }
  }

  const showsPayPal = () => {
    if (currentProfile.subscription === false) {
      if (paymentTypePayPal === true) {
        return (
          <Card className='mt-1'>
            <Card.Body className='text-center'>
              <h3>Pagar con PayPal (en $US)</h3>

              <p>
                {" "}
                Haz click en el siguiente botón para pagar tu inscripción usando
                PayPal. En la descripción incluye "BCDE14" y el número de
                confirmación de tu documento.
              </p>

              <span className='text-secondary fs-4'>
                {" "}
                Pay with PayPal (in $US)
              </span>

              <p className='text-secondary fs-9'>
                {" "}
                Use the button below to pay your registration through PayPal. In
                the description include "BCDE14" and your paper confirmation
                number.
              </p>

              <Button variant='warning' onClick={redirectToExternalURL}>
                PayPal.Me/SEBOLBCDE
              </Button>
              <div>
                {/* <p>Submit your payment here:</p>
                <p>
                  <a
                    href="https://www.paypal.com/paypalme/SEBOLBCDE"
                    target="_blank"
                  >
                    https://www.paypal.com/paypalme/SEBOLBCDE
                  </a>
                </p> */}
              </div>
            </Card.Body>
          </Card>
        )
      } else if (paymentTypeQR === true) {
        return (
          <Card className='mt-1'>
            <Card.Body className='text-center'>
              <h3>Pagar con QR (en bolivianos)</h3>
              <p>
                {" "}
                Solo para usuarios de bancos Bolivianos que permitan realizar
                pagos QR
              </p>

              <span className='text-secondary fs-4'>
                {" "}
                QR payment (in bolivian pesos)
              </span>

              <p className='text-secondary fs-9'>
                {" "}
                Just for users of Bolivian banks that supports QR payments
              </p>
              <div>
                <Alert variant='danger'>Registration Is Closed</Alert>
                {/* <Button
                  variant='success'
                  disabled={loading}
                  className='w-100 mt-4'
                  type='submit'
                  onClick={handleSubscribe}
                >
                  Pagar | Pay
                </Button> */}
              </div>
            </Card.Body>
          </Card>
        )
      }
    } else {
      ;<></>
    }
  }

  const showData = () => {
    switch (dataSelect?.value) {
      case "Expositor":
        return (
          <>
            <h3 className='text-center'>
              345 Bs | <span className='text-secondary'>50 $US</span>
            </h3>
            <hr className='hr-danger' />
            <h2 className='mt-4 text-center'>Incluye con tu inscripción</h2>
            <p className='mt-4 fs-6 text-secondary text-center'>
              Included in your registration
            </p>
            <ul className='mx-1'>
              <li>
                Almuerzo <br />{" "}
                <span className='text-secondary fs-9'> Lunch</span>
              </li>
              <li>
                Café y refrigerios <br />{" "}
                <span className='text-secondary fs-9'> Coffee and snacks</span>
              </li>
              <li>
                Cena para expositores <br />{" "}
                <span className='text-secondary fs-9'> Conference dinner</span>
              </li>
              <li>
                Material de conferencia <br />{" "}
                <span className='text-secondary fs-9'>
                  {" "}
                  Conference material
                </span>
              </li>
              <li>
                Certificado de participación <br />{" "}
                <span className='text-secondary fs-9'>
                  {" "}
                  Certificate of attendance
                </span>
              </li>
              <li>
                Membresia 2023 SEBOL <br />
                <span className='text-secondary fs-9'>
                  {" "}
                  2023 SEBOL membership
                </span>
              </li>
            </ul>
            {/* <Alert className='text-center'>
              <p>Presenter Registration is Closed. </p>
              <p>
                Please contact{" "}
                <a href='mailto:bcde14@sebol.org'>bcde14@sebol.org</a> if you
                missed the registration deadline.
              </p>
            </Alert> */}
            <Button
              disabled={loading}
              variant='success'
              className='w-100 mt-4 p-1'
              onClick={handlePaymentQR}
            >
              Pagar con codigo QR | Pay with QR code
            </Button>

            {/* <Button
              disabled={loading}
              variant='warning'
              className='w-100 mt-4 p-1'
              onClick={handlePaymentPayPal}
            >
              Pagar con PayPal | Pay with Paypal
            </Button> */}
          </>
        )

      case "Student":
        return (
          <>
            <h3 className='text-center'>100 Bs</h3>
            <hr className='hr-danger' />
            <h2 className='mt-4 text-center'>Incluye con tu inscripción</h2>
            <p className='mt-4 fs-6 text-secondary text-center'>
              Included in your registration
            </p>
            <ul className='mx-1'>
              <li>
                Café y refrigerios <br />{" "}
                <span className='text-secondary fs-9'> Coffee and snacks</span>
              </li>
              <li>
                Material de conferencia <br />{" "}
                <span className='text-secondary fs-9'>
                  {" "}
                  Conference material
                </span>
              </li>
              <li>
                Certificado de participación <br />{" "}
                <span className='text-secondary fs-9'>
                  {" "}
                  Certificate of attendance
                </span>
              </li>
              <li>
                Membresia Estudiante 2023 SEBOL <br />
                <span className='text-secondary fs-9'>
                  {" "}
                  2023 SEBOL student membership
                </span>
              </li>
            </ul>
            <Button
              disabled={loading}
              variant='success'
              className='w-100 mt-4 p-1'
              onClick={handlePaymentQR}
            >
              Pagar con codigo QR | Pay with QR code
            </Button>
          </>
        )

      case "Professional":
        return (
          <>
            <h3 className='text-center'>250 Bs</h3>
            <hr className='hr-danger' />
            <h2 className='mt-4 text-center'>Incluye con tu inscripción</h2>
            <p className='mt-4 fs-6 text-secondary text-center'>
              Included in your registration
            </p>
            <ul className='mx-1'>
              <li>
                Almuerzo <br />{" "}
                <span className='text-secondary fs-9'> Lunch</span>
              </li>
              <li>
                Café y refrigerios <br />{" "}
                <span className='text-secondary fs-9'> Coffee and snacks</span>
              </li>
              <li>
                Material de conferencia <br />{" "}
                <span className='text-secondary fs-9'>
                  {" "}
                  Conference material
                </span>
              </li>
              <li>
                Certificado de participación <br />{" "}
                <span className='text-secondary fs-9'>
                  {" "}
                  Certificate of attendance
                </span>
              </li>
              <li>
                Membresia 2023 SEBOL <br />
                <span className='text-secondary fs-9'>
                  {" "}
                  2023 SEBOL membership
                </span>
              </li>
            </ul>
            <Button
              disabled={loading}
              variant='success'
              className='w-100 mt-4 p-1'
              onClick={handlePaymentQR}
            >
              Pagar con codigo QR | Pay with QR code
            </Button>
          </>
        )

      default:
        return <></>
    }
  }
  const handleDownload = () => {
    if (responseRq) {
      const fileName = "Qr_order_" + Date.now().toString()
      const source = `data:application/jpg;base64,${responseRq.qr}`
      const link = document.createElement("a")
      link.href = source
      link.download = `${fileName}.jpg`
      link.click()
    }
  }
  const handleSelect = (e) => {
    const ds = optionRegistration.find((item) => item.value === e)
    setDataSelect(ds)
    const profileNew = { ...currentProfile, category: dataSelect.value }
    setCurrentProfile(profileNew)
  }

  let fullName = currentProfile.Name + " " + currentProfile.Surname

  return (
    <CenteredContainer>
      <Card>
        <Image
          src={require("../images/Group12.jpg")}
          rounded
          className='w-100'
          style={{ maxWidth: "400px" }}
        ></Image>
      </Card>

      {/* Modal QR */}
      {/* {responseRq && (
        <Modal show={visibleQr} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title className='ms-auto'>BCDE 2022</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div>
              <div className='fs-6 test-justify mb-2'>
                Para inscribirte en la conferencia necesitas pagar el siguiente
                código QR usando la aplicación de tu banco. El código QR es
                personalizado y expirará despues de un día.{" "}
              </div>
              <div className='fs-6 text-secondary text-justify'>
                To register for the conference you need to pay the following QR
                code through your banking app. This QR code is personalized and
                will expire within one day.
              </div>
            </div>

            <div className={"d-flex flex-column"}>
              {LoadSpinner()}

              <div className='d-flex justify-content-center'>
                <img src={`data:image;base64,${responseRq?.qr}`} alt='Qr' />
              </div>

              <div>
                <p className='text-primary text-center'>
                  Precio: {responseRq?.total} Bs
                </p>
              </div>

              <div>
                <Alert variant='warning'>
                  <div className='text-center'>
                    <div className='fs-5'>
                      Pendiente
                      <hr className='hr-danger' />
                    </div>

                    <div>
                      Categoria:
                      <p className=' text-success text-center'>
                        {responseRq?.concept}{" "}
                      </p>
                    </div>

                    <div>
                      <hr className='hr-danger' />
                      Código QR expira en:
                      <div className='text-danger text-center'>
                        {responseRq?.expiration_date}
                      </div>
                    </div>
                  </div>
                </Alert>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className={"d-flex justify-content-around w-100"}>
              <Button
                className={"w-50 m-1"}
                variant='secondary'
                onClick={() => handleDownload()}
              >
                Descargar
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      )} */}

      {/* Card: Mis Datos */}
      <Card className='mt-1'>
        {LoadSpinner()}

        <Card.Body className='mt-2 p-4'>
          <h2 className='text-center mb-2'>Mis Datos</h2>
          <p className='text-center fs-6 text-secondary'> My Profile</p>

          {currentUser?.photoURL && (
            <Image
              src={currentUser?.photoURL}
              roundedCircle
              className='mx-auto d-block'
              style={{ maxWidth: "40px" }}
            ></Image>
          )}
          <hr className='hr-danger' />
          {!loading && (
            <>
              <div className='p-1 d-flex flex-row justify-content-between'>
                <div>
                  Nombre completo:
                  <div className='text-secondary'>Full name</div>
                </div>
                <div>{fullName}</div>
              </div>

              <div className='p-1 d-flex flex-row justify-content-between'>
                <div>
                  Institución:
                  <div className='text-secondary'>Affiliation</div>
                </div>
                <div>{currentProfile.Affiliation}</div>
              </div>

              <div className='p-1 d-flex flex-row justify-content-between'>
                <div>
                  Título académico:
                  <div className='text-secondary'>Academic degree</div>
                </div>
                <div>{currentProfile.Degree}</div>
              </div>

              <div className='p-1 d-flex flex-row justify-content-between'>
                <div>
                  Ocupación:
                  <div className='text-secondary'>Occupation</div>
                </div>
                <div>{currentProfile.occupation}</div>
              </div>

              <div className='p-1 d-flex flex-row justify-content-between'>
                <div>
                  Correo electrónico:
                  <div className='text-secondary'>Email</div>
                </div>
                <div>{currentProfile.email}</div>
              </div>

              {currentProfile?.paperID !== "" && currentProfile?.paperID && (
                <div className='p-1 d-flex flex-row justify-content-between'>
                  <div>Paper ID:</div>
                  <div>{currentProfile.paperID}</div>
                </div>
              )}

              <hr className='hr-danger' />

              <div className='w-100 text-center mt-2'>
                <Button
                  variant='link'
                  className='w-100 mt-2'
                  onClick={() => history.push("/update")}
                >
                  Actualizar datos | Update profile
                </Button>
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      {currentProfile.paperID === null && (
        <Card className='mt-1'>
          <h2 className='mt-4 text-center'>Tu Documento</h2>
          <p className='text-center fs-6 text-secondary'> Your Paper</p>{" "}
          <Card.Body>
            <div className='w-100 fs-16 text-center'>
              Por favor incluye el ID de confirmacion tu documento.
            </div>
            <div className='w-100 fs-16 text-secondary mt-0 text-center'>
              Please include you paper confirmation ID.
            </div>

            <Form onSubmit={handlePaperId}>
              <Form.Group id='paperID' className='mt-3'>
                <Form.Label column xs={5}>
                  Paper ID
                </Form.Label>
                <Form.Control
                  required
                  type='text'
                  placeholder='Paper ID'
                  ref={paperRef}
                  size='sm'
                />
              </Form.Group>
              <Button disabled={loading} className='w-100 mt-4' type='submit'>
                Guardar | Save
              </Button>
            </Form>
          </Card.Body>
        </Card>
      )}

      {/* Card QR Status  */}
      {!loading && (
        <Card className='mt-1'>
          <Card.Body>
            <>
              <h2 className='text-center mb-4 mt-2 '>Inscripción BCDE</h2>
              <p className='text-center fs-6 text-secondary'>
                {" "}
                BCDE registration
              </p>
              {error && <Alert variant='danger'>{error}</Alert>}

              {showStatusQr()}

              {/* <h4 className="text-left mb-2 mt-2">Status: </h4> */}
              {showActionSubscribe()}
            </>
          </Card.Body>
        </Card>
      )}

      {showsPayPal()}

      {!loading && (
        <Card className='mt-1'>
          <Card.Body>
            {/* { currentUser.becario !== true &&
           <>
            <h2 className="text-center mb-4 mt-2 ">Inscripción BCDE</h2>
            <p className="text-center fs-6 text-secondary"> BCDE registration</p>
            {error && <Alert variant="danger">{error}</Alert>}
            { showStatusQr()}

            { showActionSubscribe()}
            </> 
            } */}

            {currentAdmin && (
              <>
                <Button
                  className='w-100 mt-2'
                  onClick={() => history.push("/admin")}
                >
                  Lista de inscritos
                </Button>
                <Button
                  variant='info'
                  className='w-100 mt-2'
                  onClick={() => history.push("/admin/pendientes")}
                >
                  Validar pendientes
                </Button>
              </>
            )}
          </Card.Body>
        </Card>
      )}

      <Card className='mt-1'>
        <div className='text-center'>
          <p className='text-center text-secondary mt-2'>
            {" "}
            Questions? <a href='mailto:bcde14@sebol.org'> Email us</a>
          </p>
        </div>
        <div>
          <p className='text-center text-secondary mt-2'> Powered by:</p>
          <Image
            src={require("../images/LogoRapiReservas.png")}
            rounded
            className='mx-auto d-block'
            style={{ maxWidth: "80px" }}
          ></Image>
        </div>
      </Card>

      {/* Log out */}
      <div className='w-100 text-center'>
        <Button
          className='w-50 mt-1 text-danger'
          variant='link'
          onClick={handleLogout}
        >
          Salir | Log out
        </Button>
      </div>
    </CenteredContainer>
  )
}
